import { ReactComponent as Logo } from '../media/logo-icon.svg';
import styled from "styled-components";
import { Anchor } from './Button';
import { BurgerMenu } from './BurgerMenu';
import { LanguageSelection } from './LanguageSelection';
import { useTranslation, Trans } from "react-i18next";
import { namespaces } from "../i18n.costants";
import { AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

export function Header() {
  const { t } = useTranslation(namespaces.common);

  return (
    <Wrapper>
      <Content>
        <LogoAndText>
          <LogoContainer as={Link} to={`/#${t("nav/home")}`}>
            <Logo fill="var(--color-blue-dark)" color="var(--color-blue-dark)" />
          </LogoContainer>
          <Title>VEV SERVIZI</Title>
          <Subtitle>{t("FORNITURE • MONTAGGI • MANUTENZIONI")}</Subtitle>
        </LogoAndText>

        <NavBar>
          <NavItem><Anchor href={`#${t("nav/home")}`} underlineOnHover={true} text={t("Home")} /></NavItem>
          <NavItem><Anchor href={`#${t("nav/about-us")}`} underlineOnHover={true} text={t("Chi siamo")} /></NavItem>
          <NavItem><Anchor href={`#${t("nav/home-renovation")}`} underlineOnHover={true} text={<Trans shouldUnescape={true}>Ristrutturazione chiavi in mano</Trans>} /></NavItem>
          <NavItem><Anchor href={`#${t("nav/office-renovation")}`} underlineOnHover={true} text={<Trans shouldUnescape={true}>Arredo ufficio</Trans>} /></NavItem>
          <NavItem><LanguageSelection /></NavItem>
          <NavItem><Anchor
            href={`#${t("nav/contact")}`}
            underlineOnHover={true}
            textColor="white"
            backgroundColor='var(--color-blue-gradient)'
            text={t("Contattaci")}
          /></NavItem>
        </NavBar>

        <BurgerMenu initialFocus="#home-button">
          <Anchor href={`#${t("nav/home")}`} underlineOnHover={true} text={t("Home")} id="home-button" />
          <Anchor href={`#${t("nav/about-us")}`} underlineOnHover={true} text={t("Chi siamo")} />
          <Anchor href={`#${t("nav/home-renovation")}`} underlineOnHover={true} text={t("Ristrutturazione chiavi in mano")} />
          <Anchor href={`#${t("nav/office-renovation")}`} underlineOnHover={true} text={t("Arredo ufficio")} />

          <LanguageSelection />
          <Anchor href={`#${t("nav/contact")}`} underlineOnHover={true} text={t("Contattaci")} />
        </BurgerMenu>
      </Content>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: var(--color-gray-light);
  position: sticky;
  top: 0;
  z-index: 2;
  height: var(--header-height);
`;
const Content = styled.div`
  max-width: var(--content-width);
  margin: auto;
  padding: 5px 0;
  display: flex;
  gap: var(--gap);
  justify-content: space-between;
  height: 100%;

  @media (max-width: 1300px) {
    padding: 5px var(--gap);
  }
`;
const NavBar = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  @media (max-width: 1050px) {
    display: none;
  } 
`;
const NavItem = styled.li`
  display: flex;
  align-items: stretch;
  
  &:last-of-type a {
    align-self: center;
  }
`;
const LogoContainer = styled.a<AnchorHTMLAttributes<HTMLAnchorElement>>`
  width: 80px;
  grid-column: 1;
  grid-row: span 2;
  height: max-content;
  
  @media (max-width: 1300px) {
    width: 60px;
    align-self: center;
  } 
`;
const LogoAndText = styled.div`
  font-family: var(--heading-font), sans-serif;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 10px;
  color: var(--color-text);
`;
const Title = styled.div`
  font-size: 1rem;
  align-self: end;
  font-weight: 600;
  @media (max-width: 500px) {
    display: none;
  }
`;
const Subtitle = styled.div`
  line-height: 0.8rem;
  font-size: 0.8rem;
  align-self: baseline;
  @media (max-width: 500px) {
    display: none;
  }
`;